module.exports = __webpack_public_path__ + "img/failed_camera.f9fb3d96.svg";